var moment = require('moment')
var axiosinstance = require('axios')
module.exports = {
  timeFormat (time) {
    var timeFormat = moment(time, 'HH:mm:ss')
    return time ? timeFormat.format('HH:mm') : ''
  },

  convertHourStringToMinute (str) {
    var time = moment(str, 'HH:mm')
    return Number(time.hours() * 60 + time.minutes())
  },

  convertHourStringToHour (str) {
    var time = moment(str, 'HH:mm')
    return Number(time.hours() + time.minutes() / 60).toFixed(2)
  },

  minutesToHhMm: function (mins) {
    return moment.utc().startOf('day').add(mins, 'minutes').format('HH:mm')
  },

  timeBetween: function (start, end, unit = 'm') {
    return end.diff(start, unit)
  },

  // calculate real working time in minute
  getTimeSpendInMinute: function (start, end, lunchTime) {
    var endRange = moment('05:00', 'HH:mm')
    var time = 0

    var rangeTime = this.timeBetween(start, end)
    if (lunchTime >= Math.abs(rangeTime) / 60) {
      return 0
    }

    if (rangeTime <= 0 && this.timeBetween(endRange, end) <= 0) {
      time = rangeTime + 24 * 60
    } else if (rangeTime > 0) {
      time = rangeTime
    }
    var NORMAL_LUNCH_HOURS = lunchTime * 60
    return time - NORMAL_LUNCH_HOURS
  },

  // get year holiday of country in range time from ~ to
  // from and to value in DD-MM-YYYY format
  getYearHoliday (from, to, country, callback) {
    return axiosinstance.get('//kayaposoft.com/enrico/json/v1.0/?action=getPublicHolidaysForDateRange&fromDate=' + from + '&toDate=' + to + '&country=' + country,
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      })
      .then(function (response) {
        callback(response.data)
      })
      .catch(function (error) {
        console.log('failed with error: ' + error)
      })
  },

  // round working time to calculate OT time
  // input in format HH:mm
  roundWorkingTime (stringTime) {
    var minTime = this.convertHourStringToMinute(stringTime)
    var blockMinute = 15 // round to block 15 minutes
    minTime = Math.floor(minTime / blockMinute) * blockMinute
    return this.minutesToHhMm(minTime)
  },

  empty (value) {
    return !value || value === '' || value === 0 || value === '0' || value === 0.0 || value === [] || value === {}
  }
}



// WEBPACK FOOTER //
// ./client/services/ultilities.js